import script from "./BackupSettingUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./BackupSettingUpload.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__